import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home_page.vue'
// import store from '../store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
  },
  {
    path: '/Register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('../views/forget_page.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页' }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service_page.vue'),
    meta: { title: '服务' }
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/details_page.vue'),
    meta: { title: '' }//详情
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About_page.vue'),
    meta: { title: '企业展示' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact_page.vue'),
    meta: { title: '数据资产融资' }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user_page.vue'),
    meta: { title: '' }
  }
  
  // {
  //   path: '/Product',
  //   name: 'Product',
  //   component: () => import('../views/Product_filter.vue'),
  //   meta: { title: '产品筛选' }
  // },
  // {
  //   path: '/brand',
  //   name: 'brand',
  //   component: () => import('../views/brand_query.vue'),
  //   meta: { title: '商标查询' }
  // },
  // {
  //   path: '/glossary',
  //   name: 'glossary',
  //   component: () => import('../views/glossary_govern.vue'),
  //   meta: { title: '词库管理' }
  // },
  // {
  //   path: '/bookmark',
  //   name: 'bookmark',
  //   component: () => import('../views/bookmark_page.vue'),
  //   meta: { title: '收藏夹' }
  // },
  // {
  //   path: '/details',  
  //   name: 'details',
  //   component: () => import('../views/product_details.vue'),
  //   meta: { title: '' }//产品详情
  // }
  
  
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// const whiteList = ['/login', '/Register', '/forget'] // 白名单

// router.beforeEach((to, from, next) => {
//   const isLogin = !!localStorage.getItem('token') // 获取登录状态

//   if (isLogin) {
//     // 1. 已登录
//     if (to.path === '/login' || to.path === '/Register' || to.path === '/forget') {
//       // 如果已登录且想去登录页，强制去首页（防止死循环或重复登录）
//       next({ path: '/' }) 
//     } else {
//       // 正常访问其他页面，放行
//       next()
//     }
//   } else {
//     // 2. 未登录
//     if (whiteList.includes(to.path)) {
//       // 如果是去登录页，直接放行
//       next()
//     } else {
//       // 如果去其他页面，重定向到登录页
//       next({ path: '/login', query: { redirect: to.fullPath } })
//     }
//   }
// })
export default router
